import dayjs from 'dayjs';

/**
 * 克隆
 * @param {*} obj 克隆的对象
 * @param {Boolean} deep 是否深度克隆
 * @returns
 */
export function clone(obj, deep: boolean) {
  if (Array.isArray(obj)) {
    //如果是数组
    if (deep) {
      let tempArr = [];
      obj.forEach((item) => {
        tempArr.push(clone(item, deep));
      });
      return tempArr;
    } else {
      return obj.slice(); //复制数组
    }
  } else if (typeof obj === 'object') {
    //如果是对象
    let newObj = {};
    for (const key in obj) {
      if (deep) {
        newObj[key] = clone(obj[key], deep);
      } else {
        newObj[key] = obj[key];
      }
    }
    return newObj;
  } else {
    //如果是基本类型
    return obj;
  }
}

/**
 * 睡眠函数
 * @param gap 睡眠时常
 */
export function sleep(gap: number) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true);
    }, gap);
  });
}

// 消息时间handle

export const handleMsgTime = (time) => {
  let currentTime = new Date().getTime();
  let timeDiff = Math.floor((currentTime - time) / 1000 / 60);
  const endOfToday = new Date().setHours(23, 59, 59, 999);
  if (timeDiff < 1) {
    return '刚刚';
  } else if (timeDiff >= 1 && timeDiff < 5) {
    return `${timeDiff}分钟前`;
  } else if (timeDiff >= 5) {
    const date = new Date(time)
    const now = new Date()
    if( date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      date.getDate() === now.getDate()) {
      return dayjs(time).format('HH:mm')
    } else {
      return dayjs(time).format('MM-DD');
    }
  }
};

/**
 * 获取当地时间/UTC时间
 * @param zone 时区
 * @param isUTC utc还是其他时区
 * @returns 时间戳
 * @tips 获取UTC时间，getLocalTime(0);
 */
export const getLocalTime = (zone: number): number => {
  const d = new Date();
  const len = d.getTime();
  if (zone === 0) {
    return len;
  }
  //本地时间与UTC时间的时间偏移差
  const offset = d.getTimezoneOffset() * 60000;
  //得到现在的UTC时间，各时区UTC时间相同
  const utcTime = len + offset;

  return new Date(utcTime + 3600000 * zone).getTime();
};

export const getZoneOffset = (): number => {
  const timezoneOffsetMinutes = new Date().getTimezoneOffset();

  const timezoneOffsetHours = -timezoneOffsetMinutes / 60;

  const formattedTimezoneOffset = (timezoneOffsetHours >= 0 ? '+' : '-') + timezoneOffsetHours;

  return +formattedTimezoneOffset;
};

export const formatTime = (utcTimestamp: number, format: string) => {
  const offset = getZoneOffset();
  // 将 UTC 时间转换为中国本地时间（UTC+8）
  const offsetTime = offset * 3600 * 1000;
  return handleMsgTime(utcTimestamp);
};

/**
 * 解析地址栏信息
 * @param url 地址栏
 * @returns
 */
export const queryURLparams = (url: string = location.href) => {
  let obj: any = {};
  if (url.indexOf('?') < 0) return obj;
  let arr = url.split('?');

  // 去除掉第一项(baseUrl)
  const t1 = arr.filter((item, inx) => inx > 0);

  for (let j = 0, jlen = t1.length; j < jlen; j++) {
    const l = t1[j];
    const tArr = l.split('&');

    for (let i = 0; i < tArr.length; i++) {
      let arr2 = tArr[i];
      let arr3 = arr2.split('=');
      obj[arr3[0]] = arr3[1];
    }
  }

  return obj;
};

// 判断是否为JSON
export const isJSON = (str) => {
  const jsonRegex = /^\s*[\[\{]/;
  if (!jsonRegex.test(str)) {
      return false;
  }
  try {
      JSON.parse(str);
      return true;
  } catch (e) {
      return false;
  }
}
